import { render, staticRenderFns } from "./SetSiteSettings.vue?vue&type=template&id=0c58db4c&"
import script from "./SetSiteSettings.vue?vue&type=script&lang=js&"
export * from "./SetSiteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports